var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState } from 'react';
import moment from 'moment';
import { h } from '@debbie/cortex/dist';
import { parkingLotRemarksKey, useParkingLotRemarks, } from '@debbie/cortex/dist/parking';
import Button from '../Button';
import * as parkingAPI from '@debbie/cortex/dist/api/parking';
import q from '@debbie/cortex/dist/query';
import { ParkingLotRemarkType, } from '@debbie/common/dist/parking';
import Input from '../Input';
import DateInput from '../DateInput';
import PowerTable, { FilterType } from '../PowerTable';
import PerformedBy from '../performed-by/PerformedBy';
import styled from 'styled-components';
import { Edit } from '../Icons';
import Modal from '../Modal';
const ParkingLotRemarks = (props) => {
    const { parkingLotReferenceId } = props;
    const parkingLotRemarksLoadable = useParkingLotRemarks(parkingLotReferenceId);
    const parkingLotRemarks = h.isLoaded(parkingLotRemarksLoadable)
        ? parkingLotRemarksLoadable.data
        : null;
    const [editRemark, setEditRemark] = useState(null);
    console.log({ parkingLotRemarks });
    const valid = (date) => {
        return !date || moment(date).isAfter(moment());
    };
    return (React.createElement(React.Fragment, null,
        editRemark && (React.createElement(Modal, { header: "Rediger eller slet bem\u00E6rkning", maxWidth: "600px", onToggle: () => setEditRemark(null) },
            React.createElement(Input, { placeholder: "Kommentar", value: editRemark.comment, onChange: (e) => setEditRemark(Object.assign(Object.assign({}, editRemark), { comment: e.target.value })) }),
            React.createElement(DateInput, { placeholder: 'Gyldig til', showTimeSelect: true, onChange: (date) => setEditRemark(Object.assign(Object.assign({}, editRemark), { validTo: (date === null || date === void 0 ? void 0 : date.format()) || null })), value: editRemark.validTo ? moment(editRemark.validTo) : null, allowNull: true }),
            React.createElement(Button, { onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                    try {
                        yield parkingAPI.patchParkingLotRemark(editRemark.parkingLotRemarkId, {
                            comment: editRemark.comment,
                            validTo: editRemark.validTo,
                        });
                        q.invalidate([parkingLotRemarksKey(parkingLotReferenceId)]);
                        setEditRemark(null);
                    }
                    catch (error) {
                        alert('Error');
                    }
                }), block: true, theme: "secondary", style: { marginTop: '10px' } }, "Gem"),
            React.createElement(Button, { theme: "dangerous", onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                    try {
                        yield parkingAPI.deleteParkingLotRemark(editRemark.parkingLotRemarkId);
                        q.invalidate([parkingLotRemarksKey(parkingLotReferenceId)]);
                        setEditRemark(null);
                    }
                    catch (error) {
                        alert('Error');
                    }
                }), block: true, style: { marginTop: '10px' } }, "Slet bem\u00E6rkning til pladsen"))),
        parkingLotRemarks && (React.createElement(Wrapper, null,
            React.createElement(PowerTable, { data: parkingLotRemarks, genKey: (dpt) => JSON.stringify(dpt), pagination: {
                    type: 'none',
                    pageSize: parkingLotRemarks.length,
                }, values: {
                    createdAt: {
                        label: 'Oprettet',
                        toCmp: (createdAt) => createdAt,
                        width: '100px',
                        map: (startingDate, row) => {
                            return (React.createElement("div", { style: { opacity: valid(row.validTo) ? 1 : 0.5 } },
                                React.createElement(Edit, { style: { cursor: 'pointer' }, onClick: () => setEditRemark(row) }),
                                ' ',
                                moment(startingDate).format('DD/MM/YYYY HH:mm')));
                        },
                        filter: {
                            type: FilterType.DateRange,
                        },
                    },
                    comment: {
                        label: 'Kommentar',
                        toCmp: (comment) => comment,
                        map: (comment, row) => {
                            return (React.createElement("div", { style: { opacity: valid(row.validTo) ? 1 : 0.5 } }, comment));
                        },
                    },
                    validTo: {
                        label: 'Gyldig til',
                        toCmp: (validTo) => validTo || '-',
                        map: (validTo) => {
                            return (React.createElement("div", { style: { opacity: valid(validTo) ? 1 : 0.5 } }, validTo
                                ? moment(validTo).format('DD/MM/YYYY HH:mm')
                                : '-'));
                        },
                        // @ts-ignore
                        filter: {
                            type: FilterType.DateRange,
                        },
                    },
                    createdBy: {
                        label: 'Oprettet af',
                        toCmp: () => 0,
                        map: (performedBy) => {
                            return React.createElement(PerformedBy, { performedBy: performedBy });
                        },
                    },
                }, searchable: true, toSearchStr: (dpt) => JSON.stringify(dpt), defaultSortDirection: "DESC", defaultSortKey: "createdAt" })))));
};
export default ParkingLotRemarks;
const Wrapper = styled.div `
  table td {
    padding: 0.3em;
  }
`;
export const AddParkingLotRemark = (props) => {
    const { parkingLotReferenceId } = props;
    const [type, setType] = useState(ParkingLotRemarkType.Other);
    const [comment, setComment] = useState('');
    const [validTo, setValidTo] = useState(null);
    return (React.createElement(React.Fragment, null,
        React.createElement(Input, { placeholder: "Kommentar", value: comment, onChange: (e) => setComment(e.target.value) }),
        React.createElement(DateInput, { placeholder: 'Gyldig til', showTimeSelect: true, onChange: (date) => setValidTo(date), value: validTo, allowNull: true }),
        React.createElement(Button, { onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                try {
                    yield parkingAPI.createParkingLotRemark({
                        comment,
                        parkingLotReferenceId: parkingLotReferenceId,
                        type,
                        validTo: validTo ? validTo.format() : null,
                    });
                    q.invalidate([parkingLotRemarksKey(parkingLotReferenceId)]);
                    props.onAdd();
                }
                catch (error) {
                    alert('Error');
                }
            }), block: true, disabled: !comment, theme: "secondary", style: { marginTop: '10px' } }, "Tilf\u00F8j bem\u00E6rkning til pladsen")));
};
//# sourceMappingURL=ParkingLotRemarks.js.map